export const HamburgerMenuIcon = ({ ...props }) => {
  return (
    <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="m3.5 7c-.27614237 0-.5-.22385763-.5-.5s.22385763-.5.5-.5h17c.2761424 0 .5.22385763.5.5s-.2238576.5-.5.5zm0 5c-.27614237 0-.5-.2238576-.5-.5s.22385763-.5.5-.5h17c.2761424 0 .5.2238576.5.5s-.2238576.5-.5.5zm0 5c-.27614237 0-.5-.2238576-.5-.5s.22385763-.5.5-.5h17c.2761424 0 .5.2238576.5.5s-.2238576.5-.5.5z" />
    </svg>
  );
};
